(function () {
  var STORAGE_KEY = 'recently-viewed';
  var MAX_STORED = 10;
  var REMOVE_ICON =
    '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function readIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeIds(ids) {
    if (!ids.length) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_STORED)));
  }

  function saveProduct(productId) {
    if (!productId) return;
    var id = String(productId);
    var ids = readIds().filter(function (item) {
      return item !== id;
    });
    ids.unshift(id);
    writeIds(ids);
  }

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define(
      'recently-viewed',
      class RecentlyViewed extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === '1') return;
          this.dataset.ready = '1';
          saveProduct(this.dataset.productId);
          if (!this.hasAttribute('hidden') && this.querySelector('[data-rv-track] .recently-viewed__slide')) {
            this.initUi();
            return;
          }
          this.load();
        }

        load() {
          var limit = parseInt(this.dataset.limit, 10) || 8;
          var currentId = this.dataset.productId ? String(this.dataset.productId) : '';
          var ids = readIds()
            .filter(function (id) {
              return id !== currentId;
            })
            .slice(0, limit);

          if (!ids.length) {
            this.showEmpty();
            return;
          }

          var query = ids
            .map(function (id) {
              return 'id:' + id;
            })
            .join(' OR ');
          var url =
            window.location.origin +
            shopRoot() +
            'search?section_id=' +
            encodeURIComponent(this.dataset.sectionId) +
            '&type=product&q=' +
            encodeURIComponent(query);

          fetch(url, { headers: { Accept: 'text/html' } })
            .then(function (response) {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then(this.applyMarkup.bind(this, ids))
            .catch(function (error) {
              if (error && (error.name === 'AbortError' || error.name === 'TypeError')) return;
              console.error(error);
            });
        }

        applyMarkup(ids, text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var next = parsed.querySelector('recently-viewed [data-rv-root]') || parsed.querySelector('[data-rv-root]');
          var root = this.querySelector('[data-rv-root]');
          if (!next || !root) return;

          root.innerHTML = next.innerHTML;
          this.reorder(ids);
          if (!this.querySelector('.recently-viewed__slide[data-product-id]')) {
            this.showEmpty();
            return;
          }
          this.removeAttribute('hidden');
          this.toggleEmpty(false);
          this.initUi();
        }

        reorder(ids) {
          var list = this.querySelector('.recently-viewed__list');
          if (!list || !ids.length) return;
          var order = new Map(
            ids.map(function (id, index) {
              return [String(id), index];
            })
          );
          Array.from(list.children)
            .sort(function (a, b) {
              var rankA = order.has(a.dataset.productId) ? order.get(a.dataset.productId) : Number.MAX_SAFE_INTEGER;
              var rankB = order.has(b.dataset.productId) ? order.get(b.dataset.productId) : Number.MAX_SAFE_INTEGER;
              return rankA - rankB;
            })
            .forEach(function (slide) {
              list.appendChild(slide);
            });
        }

        showEmpty() {
          if (this.dataset.showEmpty === 'true') {
            this.removeAttribute('hidden');
            this.toggleEmpty(true);
          } else {
            this.setAttribute('hidden', '');
          }
        }

        toggleEmpty(isEmpty) {
          this.querySelectorAll('[data-rv-results]').forEach(function (el) {
            if (el.hasAttribute('data-rv-progress')) return;
            el.hidden = isEmpty;
          });
          var empty = this.querySelector('[data-rv-empty]');
          if (empty) empty.hidden = !isEmpty;
          var carousel = this.querySelector('.recently-viewed__carousel');
          if (carousel) carousel.hidden = isEmpty;
          var progress = this.querySelector('[data-rv-progress]');
          if (isEmpty && progress) progress.hidden = true;
        }

        initUi() {
          this.injectRemoveButtons();
          this.sizeSlides();
          this.bindCarousel();
          if (typeof window.bindProductCarousel === 'function') {
            window.bindProductCarousel(this);
          }
          this.updateProgress();
        }

        sizeSlides() {
          var carousel = this.querySelector('[data-rv-carousel]') || this.querySelector('.recently-viewed__carousel');
          if (!carousel) return;
          var styles = window.getComputedStyle(this);
          var columns = parseFloat(styles.getPropertyValue('--rv-columns')) || 2;
          var peek = parseFloat(styles.getPropertyValue('--rv-peek')) || 0;
          var gap = parseFloat(styles.getPropertyValue('--rv-gap')) || 12;
          var visible = columns + peek;
          if (visible < 1) visible = 2;
          var width = (carousel.clientWidth - (visible - 1) * gap) / visible;
          if (!isFinite(width) || width < 80) return;
          this.style.setProperty('--rv-slide-width', width + 'px');
        }

        injectRemoveButtons() {
          var label = this.dataset.removeLabel || 'Remove';
          var self = this;
          this.querySelectorAll('.recently-viewed__slide').forEach(function (slide) {
            if (slide.querySelector('.rv-remove')) return;
            var productId = slide.dataset.productId;
            if (!productId) return;
            var host = slide.querySelector('article') || slide;
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'rv-remove';
            button.setAttribute('aria-label', label);
            button.innerHTML = REMOVE_ICON;
            button.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              self.removeProduct(productId, slide);
            });
            host.appendChild(button);
          });
        }

        removeProduct(productId, slide) {
          writeIds(
            readIds().filter(function (id) {
              return id !== String(productId);
            })
          );
          if (slide) slide.remove();
          var remaining = this.querySelectorAll('.recently-viewed__slide[data-product-id]');
          if (!remaining.length) {
            this.showEmpty();
            return;
          }
          this.updateProgress();
        }

        bindCarousel() {
          var track = this.querySelector('[data-rv-track]');
          if (!track || track.dataset.bound === '1') return;
          track.dataset.bound = '1';
          var self = this;
          var dragging = false;
          var didDrag = false;
          var startX = 0;
          var startScroll = 0;
          var activePointer = null;

          function stopDrag() {
            if (!dragging) return;
            dragging = false;
            activePointer = null;
            track.classList.remove('is-dragging');
            window.setTimeout(function () {
              didDrag = false;
            }, 0);
          }

          track.addEventListener('pointerdown', function (event) {
            if (event.button !== 0) return;
            if (
              event.target.closest &&
              event.target.closest('.rv-remove, select, input, textarea, button')
            ) {
              return;
            }
            dragging = true;
            didDrag = false;
            activePointer = event.pointerId;
            startX = event.clientX;
            startScroll = track.scrollLeft;
          });

          window.addEventListener('pointermove', function (event) {
            if (!dragging || event.pointerId !== activePointer) return;
            var delta = event.clientX - startX;
            if (Math.abs(delta) < 8) return;
            if (!didDrag) {
              didDrag = true;
              track.classList.add('is-dragging');
            }
            track.scrollLeft = startScroll - delta;
            self.updateProgress();
          });

          window.addEventListener('pointerup', stopDrag);
          window.addEventListener('pointercancel', stopDrag);

          track.addEventListener(
            'click',
            function (event) {
              if (!didDrag) return;
              event.preventDefault();
              event.stopPropagation();
            },
            true
          );

          track.addEventListener('dragstart', function (event) {
            if (didDrag) event.preventDefault();
          });

          track.addEventListener(
            'scroll',
            function () {
              self.updateProgress();
            },
            { passive: true }
          );
          window.addEventListener('resize', function () {
            self.sizeSlides();
            self.updateProgress();
          });

          if (typeof ResizeObserver === 'function') {
            var ro = new ResizeObserver(function () {
              self.sizeSlides();
              self.updateProgress();
            });
            ro.observe(track);
            var list = this.querySelector('.recently-viewed__list');
            if (list) ro.observe(list);
          }

          this.querySelectorAll('.recently-viewed__slide img').forEach(function (img) {
            if (img.complete) return;
            img.addEventListener('load', function () {
              self.updateProgress();
            });
          });

          this.sizeSlides();
          this.updateProgress();
          requestAnimationFrame(function () {
            self.sizeSlides();
            self.updateProgress();
          });
          window.setTimeout(function () {
            self.sizeSlides();
            self.updateProgress();
          }, 300);
        }

        scrollMax(track) {
          var list = this.querySelector('.recently-viewed__list');
          var max = track.scrollWidth - track.clientWidth;
          if (max > 2) return max;
          if (list) {
            max = list.scrollWidth - track.clientWidth;
            if (max > 2) return max;
            var slides = list.children;
            if (slides.length) {
              var last = slides[slides.length - 1];
              max = last.offsetLeft + last.offsetWidth - track.clientWidth;
            }
          }
          return Math.max(0, max);
        }

        updateProgress() {
          this.sizeSlides();
          var track = this.querySelector('[data-rv-track]');
          var bar = this.querySelector('[data-rv-progress-bar]');
          var wrap = this.querySelector('[data-rv-progress]');
          if (!track || !bar) return;

          var slides = this.querySelectorAll('.recently-viewed__slide').length || 1;
          var styles = window.getComputedStyle(this);
          var columns = parseFloat(styles.getPropertyValue('--rv-columns')) || 2;
          var peek = parseFloat(styles.getPropertyValue('--rv-peek')) || 0;
          var visible = columns + peek || 2;
          var max = this.scrollMax(track);
          if (wrap) wrap.hidden = slides <= 1;

          var ratio = max <= 0 ? 0 : Math.min(1, Math.max(0, track.scrollLeft / max));
          var thumb = Math.min(92, Math.max(18, (visible / slides) * 100));
          bar.style.width = thumb + (100 - thumb) * ratio + '%';
        }
      }
    );
  }

  function saveFromPdp() {
    var info = document.querySelector('product-info[data-product-id]');
    if (info) saveProduct(info.dataset.productId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', saveFromPdp);
  } else {
    saveFromPdp();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('recently-viewed');
    if (el) {
      el.dataset.ready = '0';
      if (el.connectedCallback) el.connectedCallback();
    }
  });
})();
